import React, { forwardRef } from 'react';
import ReportPaper from './ReportPaper';

/**
 * PDF de um módulo que não tem template próprio (queixas, evolução,
 * anotações, anamnese, assimetria craniana no papel compartilhado): o papel
 * com o título da seção do registro e o miolo da seção.
 *
 * `section`: entrada de REPORT_SECTIONS; `job`: saída do `prepare` da seção.
 */
const ModuleReportTemplate = forwardRef(({ section, job, companyData, professional, patientName }, ref) => {
  const meta = section.meta ? section.meta(job) : {};
  const Body = section.Body;

  return (
    <ReportPaper
      ref={ref}
      companyData={companyData}
      professional={professional}
      patientName={patientName}
      title={meta.title || section.title}
      subtitle={meta.subtitle}
      date={meta.date}
    >
      <Body {...job} />
    </ReportPaper>
  );
});

ModuleReportTemplate.displayName = 'ModuleReportTemplate';

export default ModuleReportTemplate;
